/* eslint-disable */
import { endpoints } from "../../Constants";
import { authHeader, toQueryStringURL } from "../../Helpers";
import handleResponse from "../helpers";

function createPurchaseRequest(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };

    return fetch(endpoints.PURCHASE_REQUEST_CREATE, requestOptions).then(
        handleResponse
    );
}

function fetchPurchaseRequestList(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };

    return fetch(endpoints.PURCHASE_REQUEST_LIST, requestOptions).then(
        handleResponse
    );
}

function fetchPurchaseRequestDetail(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };

    return fetch(endpoints.PURCHASE_REQUEST_DETAIL, requestOptions).then(
        handleResponse
    );
}

function updatePurchaseRequestStatus(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };

    return fetch(endpoints.PURCHASE_REQUEST_UPDATE_STATUS, requestOptions).then(
        handleResponse
    );
}

function fetchPendingGrn(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };

    return fetch(endpoints.PURCHASE_REQUEST_PENDING_GRN, requestOptions).then(
        handleResponse
    );
}

export const purchaseRequestServices = {
    createPurchaseRequest,
    fetchPurchaseRequestList,
    fetchPurchaseRequestDetail,
    updatePurchaseRequestStatus,
    fetchPendingGrn,
};